import { Phone, MessageCircle } from "lucide-react";
import { CLINIC } from "@/data/clinic";

export default function FloatingCTAs() {
  return (
    <div className="fixed bottom-6 right-5 z-50 hidden md:flex flex-col gap-3" data-testid="floating-ctas">
      <a
        href={`https://wa.me/${CLINIC.whatsapp}?text=Hello%20Dr.%20Ashutosh%20Mishra,%20I%20would%20like%20to%20book%20an%20appointment.`}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-floating-btn"
        className="group w-14 h-14 rounded-full grid place-items-center bg-[#25D366] text-white shadow-lg shadow-emerald-500/30 hover:scale-105 transition-transform"
      >
        <MessageCircle className="w-6 h-6" />
        <span className="absolute right-16 bg-slate-900 text-white text-xs px-3 py-1.5 rounded-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          Chat on WhatsApp
        </span>
      </a>
      <a
        href={`tel:+91${CLINIC.phone}`}
        aria-label="Call clinic"
        data-testid="call-floating-btn"
        className="group w-14 h-14 rounded-full grid place-items-center bg-slate-900 text-white shadow-lg shadow-slate-900/30 hover:scale-105 transition-transform relative"
      >
        <Phone className="w-5 h-5" />
        <span className="absolute right-16 bg-slate-900 text-white text-xs px-3 py-1.5 rounded-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          Call Now
        </span>
      </a>
    </div>
  );
}
